<template>
  <div>
    <img
      v-if="detail.sensor"
      class="sensor-icon__icon"
      alt="Commutator sensor icon"
      src="/static/imgs/commutator-sensor.svg"
      :id="uniqueId"
    />
    <b-tooltip
      v-if="detail.sensor"
      placement="right"
      boundary="viewport"
      :target="uniqueId"
    >
      {{ $t('general.sensor') }}: {{ detail.sensor }}
    </b-tooltip>
  </div>
</template>

<script>
export default {
  name: 'SensorIcon',
  props: {
    detail: {
      type: Object,
      required: true,
    },
    uniqueId: {
      type: String,
      default: '',
      required: true,
    },
  },
};
</script>

<style lang="sass" scoped>
  .sensor-icon
    &__icon
      height: 2em
      width: 2em
      border-radius: 6px
</style>
